import { useEffect, useState } from 'react';
import DepartmentDataService from '../services/DepartmentService';

/**
 * Loads department names for MaterialTable column lookup filters (same as Events page).
 */
export function useDepartmentsOptions() {
    const [departmentsOptions, setDepartmentsOptions] = useState({});

    useEffect(() => {
        const locRaw = localStorage.getItem('loc');
        if (!locRaw) return;

        const locData = JSON.parse(locRaw);
        const handleResponse = response => {
            const options = response.data.reduce((acc, item) => {
                acc[item.name] = item.name;
                return acc;
            }, {});
            setDepartmentsOptions(options);
        };

        if (Array.isArray(locData) && locData.length > 0) {
            DepartmentDataService.getAll(locData.join(','))
                .then(handleResponse)
                .catch(e => console.error('Failed to load departments', e));
        } else {
            DepartmentDataService.adminAll()
                .then(handleResponse)
                .catch(e => console.error('Failed to load departments', e));
        }
    }, []);

    return departmentsOptions;
}
